"use strict";

var _classCallCheck = require("/app/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/app/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/app/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/app/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _camelcase = _interopRequireDefault(require("camelcase"));

var _styledComponents = require("styled-components");

var _colors = _interopRequireDefault(require("../styles/colors"));

var _TopBar = _interopRequireDefault(require("./TopBar"));

var _Search = _interopRequireDefault(require("./Search"));

var _fuzzyfile = _interopRequireDefault(require("../fuzzyfile"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Methone =
/*#__PURE__*/
function (_react$default$Compon) {
  _inherits(Methone, _react$default$Compon);

  function Methone(props) {
    var _this;

    _classCallCheck(this, Methone);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Methone).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "keydown", function (event) {
      if (event.keyCode === 27) {
        // escape
        _this.setState({
          isSearchOpen: false
        });
      } else if ((event.metaKey === true || event.ctrlKey === true) && event.keyCode === 75) {
        // cmd+k
        event.preventDefault();

        _this.setState({
          isSearchOpen: !_this.state.isSearchOpen
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "resize", function (event) {
      var isMobile = _this.barRef.current.offsetWidth < _this.barRef.current.scrollWidth;

      _this.setState({
        isMobile: isMobile,
        menuClicks: 0
      });

      if (!isMobile) {
        setTimeout(function () {
          return _this.setState({
            isMobile: _this.barRef.current && _this.barRef.current.offsetWidth < _this.barRef.current.scrollWidth
          });
        }, 10);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setSearchString", function (searchString) {
      _this.setState({
        searchString: searchString
      });
    });

    _this.state = {
      menuClicks: 0,
      isSearchOpen: false,
      searchString: '',
      fuzzes: _fuzzyfile.default.fuzzes
    };
    _this.barRef = _react.default.createRef();
    return _this;
  }

  _createClass(Methone, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (typeof window === 'undefined') return;
      fetch('/fuzzyfile', {
        credentials: 'same-origin'
      }).then(function (res) {
        if (res.ok) return res.json();else throw res;
      }).then(function (json) {
        if (json.fuzzes.length) _this2.setState({
          fuzzes: _this2.state.fuzzes.concat(json.fuzzes)
        });
      }).catch(function (res) {
        console.warn("Methone can't find a fuzzyfile for this system! Response was:", res);
      });
      window.addEventListener("keydown", this.keydown);
      window.addEventListener("resize", this.resize);
      this.resize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof window === 'undefined') return;
      window.removeEventListener("keydown", this.keydown);
      window.removeEventListener("resize", this.resize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_TopBar.default, {
        barRef: this.barRef,
        config: this.props.config,
        isMobile: this.state.isMobile,
        menuClicks: this.state.menuClicks,
        isSearchOpen: this.state.isSearchOpen,
        setSearchString: this.setSearchString,
        toggleMenu: function toggleMenu() {
          return _this3.setState({
            menuClicks: _this3.state.menuClicks + 1,
            isSearchOpen: false
          });
        },
        toggleSearch: function toggleSearch() {
          return _this3.setState({
            isSearchOpen: !_this3.state.isSearchOpen,
            menuClicks: false
          });
        }
      }, _react.default.createElement(_Search.default, {
        fuzzes: this.state.fuzzes,
        isSearchOpen: this.state.isSearchOpen
      })));
    }
  }]);

  return Methone;
}(_react.default.Component); // A helper component that just wrapps Methone with a theme.
// also sets the theme-color meta tag, because thats useful


var WithTheme =
/*#__PURE__*/
function (_react$default$Compon2) {
  _inherits(WithTheme, _react$default$Compon2);

  function WithTheme(props) {
    var _this4;

    _classCallCheck(this, WithTheme);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(WithTheme).call(this, props));
    _this4.state = {
      theme: _this4.getTheme(props)
    };
    _this4.setTheme = _this4.setTheme.bind(_assertThisInitialized(_assertThisInitialized(_this4)));

    _this4.setTheme(_this4.state.theme);

    return _this4;
  }

  _createClass(WithTheme, [{
    key: "getTheme",
    value: function getTheme(props) {
      var scheme = props.config && props.config.color_scheme;
      return _colors.default[(0, _camelcase.default)(scheme)] || _colors.default['cerise'];
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.config.color_scheme !== prevProps.config.color_scheme) {
        var theme = this.getTheme(this.props);
        this.setState({
          theme: theme
        });
        this.setTheme(theme);
      }
    }
  }, {
    key: "setTheme",
    value: function setTheme(theme) {
      if (typeof window === 'undefined') return; // Update or add meta[name="theme-color"] tag according to color_scheme
      // Just in case it is incorrect, which it often is...

      var el = document.querySelector('meta[name="theme-color"]');

      if (!el) {
        el = document.createElement('meta');
        el.name = "theme-color";
        document.head.appendChild(el);
      }

      el.content = theme.primary.main;
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_styledComponents.ThemeProvider, {
        theme: this.state.theme
      }, _react.default.createElement(Methone, {
        config: this.props.config
      }));
    }
  }]);

  return WithTheme;
}(_react.default.Component);

var _default = WithTheme;
exports.default = _default;